import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { RedeemRulesSchema } from '../models/redeem-rules.model';

export const LoadRedeemRulesData = createAction('[RedeemRules: Search]: Load Redeem Rules Data');

export const GetSchemasSuccess = createAction(
  '[RedeemRules: Search]: Get Schemas Success',
  props<{ res: RedeemRulesSchema[] }>(),
);

export const GetSchemasFailed = createAction(
  '[RedeemRules: Search]: Get Schemas Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const SelectedSchemaChanged = createAction(
  '[RedeemRules: Search]: Selected Schema Changed',
  props<{ selectedSchema: string }>(),
);

export const SearchPanelStatusChanged = createAction('[RedeemRules: Search]: Search Panel Status Changed');

export const ClearRedeemRulesOptions = createAction('[RedeemRules: Search]: Clear Redeem Rules Options');

export const SearchRedeemRules = createAction('[RedeemRules: Search]: Search Redeem Rules');

export const SearchRedeemRulesSuccess = createAction(
  '[RedeemRules: Search]: Search Redeem Rules Success',
  props<{ res: any }>(),
);

export const SearchRedeemRulesFailed = createAction(
  '[RedeemRules: Search]: Search Redeem Rules Failed',
  props<{ error: HttpErrorResponse }>(),
);
